import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api';
import toast from 'react-hot-toast';
import { Zap, MailCheck } from 'lucide-react';
import Button from '../components/Button';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handle = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      toast.error(err?.error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-box">
        <div style={{ display:'flex', alignItems:'center', gap:11, marginBottom:26 }}>
          <div style={{ width:42, height:42, background:'var(--grad)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 8px 20px var(--accent-glow)' }}>
            <Zap size={20} color="#fff" />
          </div>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:'var(--text)' }}>WP Manager</div>
            <div style={{ fontSize:11, color:'var(--text3)' }}>Password recovery</div>
          </div>
        </div>

        {sent ? (
          <>
            <h2>Check your email</h2>
            <p>If an account exists for that email, we’ve sent a password reset link. It’s valid for 1 hour.</p>
            <div style={{ display:'flex', alignItems:'center', gap:10, background:'var(--green-bg)', borderRadius:12, padding:'14px 16px', margin:'8px 0 18px' }}>
              <MailCheck size={18} color="var(--green)" />
              <span style={{ fontSize:12.5, color:'var(--green-text)' }}>Reset link sent — check your inbox &amp; spam folder.</span>
            </div>
            <p style={{ textAlign:'center', fontSize:12, color:'var(--text3)' }}>
              <Link to="/login" className="auth-link">Back to sign in</Link>
            </p>
          </>
        ) : (
          <>
            <h2>Forgot password?</h2>
            <p>Enter your account email and we’ll send you a reset link.</p>
            <form onSubmit={handle}>
              <div className="field">
                <label>Email</label>
                <input type="email" placeholder="you@example.com" value={email} onChange={e=>setEmail(e.target.value)} required />
              </div>
              <Button type="submit" className="btn primary" style={{ width:'100%', justifyContent:'center', marginTop:4 }} loading={loading}>
                {loading ? 'Sending...' : 'Send reset link'}
              </Button>
            </form>
            <p style={{ marginTop:16, textAlign:'center', fontSize:12, color:'var(--text3)' }}>
              Remembered it? <Link to="/login" className="auth-link">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
